import api, { Base, Tags } from 'ev-api/api';
import { sanitizeAndTransformResponse } from 'ev-api/common/transformers';

import {
  CreateEmrEncounterParams,
  CreateEmrPatientParams,
  EmrEncounter,
  EmrPatient,
  GetEmrEncountersParams,
  GetEmrPatientsParams,
  SelectEmrEncounterParams,
  SelectEmrPatientParams,
} from './params';

const cdxVisitEmrSearchApi = api.injectEndpoints({
  endpoints: builder => ({
    getEmrPatients: builder.mutation<EmrPatient[], GetEmrPatientsParams>({
      query: ({ practiceId, visitId, eData }) => ({
        url: `${Base.V4}/cdx_proxy/sync_event`,
        method: 'POST',
        body: {
          entity: 'visit_emr_search',
          event: 'get_emr_patients',
          correlation_id: crypto.randomUUID(),
          practice_id: practiceId,
          visit_id: visitId,
          eData: eData,
        },
      }),
      transformResponse: sanitizeAndTransformResponse,
    }),
    selectEmrPatient: builder.mutation<void, SelectEmrPatientParams>({
      query: ({ practiceId, visitId, patient }) => ({
        url: `${Base.V4}/cdx_proxy/sync_event`,
        method: 'POST',
        body: {
          entity: 'visit_emr_search',
          event: 'select_emr_patient',
          correlation_id: crypto.randomUUID(),
          practice_id: practiceId,
          visit_id: visitId,
          patient,
        },
      }),
      invalidatesTags: [Tags.User, Tags.Visits],
    }),
    createEmrPatient: builder.mutation<void, CreateEmrPatientParams>({
      query: ({ practiceId, visitId, eData }) => ({
        url: `${Base.V4}/cdx_proxy/sync_event`,
        method: 'POST',
        body: {
          entity: 'visit_emr_search',
          event: 'create_emr_patient',
          correlation_id: crypto.randomUUID(),
          practice_id: practiceId,
          visit_id: visitId,
          eData: eData,
        },
      }),
      invalidatesTags: [Tags.User, Tags.Visits],
    }),
    getEmrEncounters: builder.query<EmrEncounter[], GetEmrEncountersParams>({
      query: ({ practiceId, visitId }) => ({
        url: `${Base.V4}/cdx_proxy/sync_event`,
        method: 'POST',
        body: {
          entity: 'visit_emr_search',
          event: 'get_emr_encounters',
          correlation_id: crypto.randomUUID(),
          practice_id: practiceId,
          visit_id: visitId,
        },
      }),
      transformResponse: sanitizeAndTransformResponse,
    }),
    selectEmrEncounter: builder.mutation<void, SelectEmrEncounterParams>({
      query: ({ practiceId, visitId, encounter }) => ({
        url: `${Base.V4}/cdx_proxy/sync_event`,
        method: 'POST',
        body: {
          entity: 'visit_emr_search',
          event: 'select_emr_encounter',
          correlation_id: crypto.randomUUID(),
          practice_id: practiceId,
          visit_id: visitId,
          encounter,
        },
      }),
      invalidatesTags: [Tags.Visits],
    }),
    createEmrEncounter: builder.mutation<void, CreateEmrEncounterParams>({
      query: ({ practiceId, visitId }) => ({
        url: `${Base.V4}/cdx_proxy/sync_event`,
        method: 'POST',
        body: {
          entity: 'visit_emr_search',
          event: 'create_emr_encounter',
          correlation_id: crypto.randomUUID(),
          practice_id: practiceId,
          visit_id: visitId,
        },
      }),
      invalidatesTags: [Tags.Visits],
    }),
  }),
});

export const {
  useGetEmrPatientsMutation,
  useSelectEmrPatientMutation,
  useCreateEmrPatientMutation,
  useGetEmrEncountersQuery,
  useSelectEmrEncounterMutation,
  useCreateEmrEncounterMutation,
} = cdxVisitEmrSearchApi;
